<template>
  <div id="app" class="db">
    <el-container class="db-container" v-if="!$route.meta.hidden">
      <el-aside class="left-box" width="210px">
        <!-- 左侧导航 -->
        <el-menu :default-active="activeMenu" class="db-menu-bar" router unique-opened background-color="#2F404F"
                 text-color="#ffffff" active-text-color="#ffed2b">
          <template v-for="(route, index) in $router.options.routes[$router.options.routes.length - 1].children"
                    v-key="index" v-if="access(route.meta.role)">
            <el-submenu :index="route.name" v-if="route.children" :key="index">
              <template slot="title">
                <icon :name="route.iconClass"></icon>
                <span>{{ route.name }}</span>
              </template>
              <el-menu-item :index="tRoute.name" :route="tRoute" v-for="(tRoute, i) in route.children" :key="i"
                            v-if="access(tRoute.meta.role)">
                {{ tRoute.name }}
                <el-badge :hidden="false" :value="getMenuTotal(tRoute)" class="badge-item"
                          v-if="getMenuTotal(tRoute)"></el-badge>
              </el-menu-item>
            </el-submenu>
            <el-menu-item :index="route.name" :key="index" :route="route" v-else>
              <icon :name="route.iconClass"></icon>
              <span>{{ route.name }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>
      <el-container>
        <!-- 头部 -->
        <el-header class="header-box">
          <div class="dictionary">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item v-for="(item, i) in breadcrumbList" :key="i" :to="item.path">
                {{ item.name }}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>

          <span class="nav-right-item user-info">
            <div class="info">
              <span>{{ userInfo ? userInfo.email : "" }}</span>
              <span
              >{{ userInfo ? userInfo.role_name : "" }}
                {{
                  userInfo
                    ? userInfo.username
                      ? "(" + userInfo.username + ")"
                      : ""
                    : ""
                }}</span
              >
            </div>
            <span class="logout" @click="logout">
              <icon class="icon" name="sign-out"></icon>Logout
            </span>
          </span>
        </el-header>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <el-container class="db" v-else>
      <router-view></router-view>
    </el-container>
  </div>
</template>

<script>
  export default {
    name: "App",
    data() {
      return {
        userInfo: {},
        activeMenu: "",
        menuTotal: {
          pending: 0,
          delay: 0
        },
        breadcrumbList: []
      };
    },
    created() {
      this.getBreadcrumb(this.$route);
    },
    mounted() {
      this.userInfo = this.$storage.get("userInfo");
      this.activeMenu = this.$route.name;
      this.changePathOfRole(this.$route);
      // && !sessionStorage.getItem('menuTotal')
      if (this.userInfo) {
        this.getMenuTotalDate();
      } else {
        this.$router.push({
          name: "Login"
        });
      }
    },

    methods: {
      // 获取面包屑
      getBreadcrumb(e) {
        const path = e.path.substr(1);
        let pathList = path.split("/");
        this.breadcrumbList = [
          {
            name: "Position"
          }
        ];
        if (pathList[0] == "orderManage") {
          this.breadcrumbList.push({
            name: "Order Manage"
          });
        }

        if (e.query.status || e.query.path || e.query.status === "0") {
          if (e.query.path) {
            if (e.query.path == "search") {
              this.breadcrumbList.push({
                name: "All Orders",
                path: "search"
              });
            } else if (e.query.path == "new") {
              this.breadcrumbList.push({
                name: "New",
                path: "new"
              });
            }
          } else {
            if (e.query.status === "0") {
              this.breadcrumbList.push({
                name: "Draft",
                path: "draft"
              });
            }
            if (e.query.status === "1") {
              this.breadcrumbList.push({
                name: "In Process",
                path: "In-Process"
              });
            }
            if (e.query.status === "2") {
              this.breadcrumbList.push({
                name: "Pending",
                path: "pending"
              });
            }
            if (e.query.status === "4") {
              this.breadcrumbList.push({
                name: "Potential Delay",
                path: "Potential-Delay"
              });
            }
          }
        }

        this.breadcrumbList.push({
          name: e.name
        });
      },
      logout() {
        this.$confirm("Are you sure you want to Logout?", "Prompt", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "info"
        })
          .then(() => {
            this.$storage.remove("userInfo");
            this.$storage.remove("token");
            this.$router.push({
              name: "Login"
            });
          })
          .catch(() => {
          });
      },
      // 判断权限
      access(roles, num, route) {
        let user = JSON.parse(localStorage.getItem("userInfo"));
        if (user) {
          let role = user.role;
          if (roles.indexOf(role) >= 0) {
            return true;
          } else {
            return false;
          }
        }
      },
      // 展示Role
      changePathOfRole(route) {
        if (route.name) {
          return;
        }
        if (!this.userInfo) {
          return;
        }

        let n = new Date().getTime() - sessionStorage.getItem("menuTotalTime");
        if (n > 60000) {
          this.getMenuTotalDate();
        }
        if (GetUrlRelativePath() !== "/#/") {
          return;
        }

        if (Number(this.userInfo.role) === 1) {
          this.$router.replace({
            path: "/PL-Learder-Manage"
          });
        } else {
          this.$router.replace({
            path: "/orderManage/search"
          });
        }
      },

      getMenuTotal(route) {
        if (route.name === "Pending") {
          return this.menuTotal.pending;
        }
        if (route.name === "Potential Delay") {
          return this.menuTotal.delay;
        }
        if (route.name === "Cancel Request") {
          return this.menuTotal.cancel;
        }
        return 0;
      },

      getMenuTotalDate() {
        this.$api.orderMenuTotal({}).then(res => {
            this.menuTotal.pending = res.data.pending;
            this.menuTotal.delay = res.data.delay;
            this.menuTotal.cancel = res.data.cancel;
            sessionStorage.setItem("menuTotalTime", `${new Date().getTime()}`);
          }, ()=> {}
        );
      }
    },
    watch: {
      $route(to) {
        this.userInfo = this.$storage.get("userInfo");
        this.activeMenu = this.$route.name;
        this.changePathOfRole(to);

        this.getBreadcrumb(to);
      }
    }
  };

  function GetUrlRelativePath() {
    var url = document.location.toString();
    var arrUrl = url.split("//");

    var start = arrUrl[1].indexOf("/");
    var relUrl = arrUrl[1].substring(start); //stop省略，截取从start开始到结尾的所有字符

    if (relUrl.indexOf("?") != -1) {
      relUrl = relUrl.split("?")[0];
    }
    return relUrl;
  }
</script>

<style lang="scss">
  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  ::-webkit-scrollbar {
    width: 16px;
    height: 16px;
    background-color: #ebeef5;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    // box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #ebeef5;
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    // box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #555;
  }

  .el-form-item__content,
  .el-input,
  .el-form-item__label,
  .el-button {
    font-size: 18px !important;
  }

  .el-button + .el-button {
    margin-left: 0;
  }

  .el-dialog__body,
  .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label,
  .el-tabs__item,
  .el-breadcrumb,
  .el-checkbox__label,
    // .el-button,
  .el-table,
    // .el-form-item__label,
    // .el-input,
  .el-select-dropdown__item,
    // .el-form-item__content,
  .el-dialog__title,
  .el-radio__label,
  .time-select-item,
  .db,
  .el-pagination button,
  .el-pagination span:not([class*="suffix"]),
  .el-pager li,
  .el-message-box__message,
  .el-date-editor .el-range-input {
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 16px !important;
  }

  .el-menu-item,
  .el-submenu__title,
  .header-box,
  .table-border-text {
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 18px !important;
  }

  .el-table thead {
    color: #333 !important;
  }

  .el-message-box {
    min-width: 500px !important;
  }

  .el-select__tags {
    display: flex;
    align-items: center;

    .el-tag {
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .db {
    height: 100vh;

    .db-container {
      height: 100%;

      .left-box {
        background: rgb(47, 64, 79);

        .el-menu {
          border: none;
        }
      }

      .header-box {
        height: 60px;
        background: #f0f0f0;
        line-height: 60px;
        display: flex;
        justify-content: space-between;

        .dictionary {
          display: flex;
          align-items: center;

          .title {
            font-size: 30px;
            font-weight: bold;
          }

          a {
            display: flex;
            align-items: center;
            font-size: 20px;
            margin-left: 20px;
            color: #1296db;

            img {
              width: 30px;
              margin-right: 5px;
            }
          }
        }

        .nav-right-item {
          display: block;
          float: right;

          &.user-info {
            display: flex;
          }

          .info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 13px;
            margin-right: 20px;
            line-height: 25px;
          }
        }

        .logout {
          cursor: pointer;

          .fa-icon {
            vertical-align: middle;
          }
        }
      }
    }

    .badge-item {
      top: -8px;
      left: -12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue